/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Note_HintInputs */

const en_us2_exercise_personal_note_hint = /** @type {(inputs: Exercise_Personal_Note_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shows here and in the workout every time this exercise comes up.`)
};

const pt_br2_exercise_personal_note_hint = /** @type {(inputs: Exercise_Personal_Note_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparece aqui e no treino, toda vez que este exercício vier.`)
};

const es_419_exercise_personal_note_hint = /** @type {(inputs: Exercise_Personal_Note_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparece aquí y en el entrenamiento cada vez que toque este ejercicio.`)
};

const pt_pt2_exercise_personal_note_hint = /** @type {(inputs: Exercise_Personal_Note_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparece aqui e no treino, sempre que este exercício surgir.`)
};

const fr_fr2_exercise_personal_note_hint = /** @type {(inputs: Exercise_Personal_Note_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'affiche ici et pendant la séance, chaque fois que cet exercice revient.`)
};

const de_de2_exercise_personal_note_hint = /** @type {(inputs: Exercise_Personal_Note_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erscheint hier und im Training, jedes Mal wenn diese Übung dran ist.`)
};

const it_it2_exercise_personal_note_hint = /** @type {(inputs: Exercise_Personal_Note_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare qui e nell'allenamento ogni volta che arriva questo esercizio.`)
};

/**
* | output |
* | --- |
* | "Shows here and in the workout every time this exercise comes up." |
*
* @param {Exercise_Personal_Note_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_note_hint = /** @type {((inputs?: Exercise_Personal_Note_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Note_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_note_hint(inputs)
	if (locale === "es-419") return es_419_exercise_personal_note_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_note_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_note_hint(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_note_hint(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_note_hint(inputs)
	return en_us2_exercise_personal_note_hint(inputs)
});
export { exercise_personal_note_hint as "exercise-personal.note_hint" }